export const API_ENDPOINTS = {
  GET_ADD_ON_ENQUIRY: '/contact/add-on-enquiries',
  UPDATE_ADD_ON_ENQUIRY: '/contact/update-enquiries-status',
  ADD_ENTERPRISE: '/enterprise/create-enterprise',
  GET_ENTERPRISES: '/enterprise/get-enterprises/',
  GET_FARMERS: '/farmer/range-data-farmers',
  ADD_FARMERS: '/farmer/create-farmer',
  UPDATE_FARMERS: '/farmer/update-is_active',
  DEACTIVATE_USER: '/users',
  ACTIVATE_USER: '/users',
  GET_All_USERS: '/farmer/metric_data/',
  GET_FARMS: '/farm/range_data_farms',
  CREATE_USER: '/auth/register',
  GET_ENTERPRISE_NAME: '/enterprise/enterprises/names',
  REGISTER_USER: '/auth/register',
  LOGIN_USER: '/auth/login',
  SEND_OTP: '/auth/send_otp',
  RESET_PASSWORD: '/auth/password-reset',
  GET_SUBSCRIPTIONS: '/subscription/get-subscriptions',
  UPDATE_SUBSCRIPTION_STATUS: '/farm/update-paid-status',
  UPDATE_SUBSCRIPTION_END_DATE: '/subscription/update-subscription-status',
  GET_SCHEDULE_CALL: '/schedule_call/get-schedule-calls',
  UPDATE_SCHEDULE_CALL_STATUS: '/schedule_call/update-schedule-call-status',
  UPDATE_ENTERPRISE: '/enterprise/update-is_active',
  GET_API_USAGE: '/api-logs/api-hits-filter',
  GET_API_LOGS: '/api-logs/api_usage',
  GET_API_LIST: '/api-logs/api_list',
  GET_API_USERLIST: '/api-logs/users',
  GET_TICKETS: '/raise_ticket/',
  UPDATE_TICKETS: '/raise_ticket/',
  GET_CONTACT_LIST: '/contact_us/',
  UPDATE_CONTACT_STATUS: '/contact_us/',
  GET_FEEDBACKS: '/feedback/',
  GET_LEADS: '/leads/get-leads',
  ADD_LEADS: '/leads/create-leads',
  DELETE_LEADS: '/leads/delete-leads',
  GET_LEADS_COUNT: '/leads/get-leads-count',
  UPDATE_LEADS: '/leads/update-leads',
  GET_ASSIGNEES: '/leads/allowed-users',
  GET_LEAD_CHART: '/leads/get-chart-data',
  GET_IOT_MAPPINGS: '/iot/farm-device-mapping',
  CREATE_IOT_MAPPING: '/iot/farm-device-mapping',
  UPDATE_IOT_MAPPING: '/iot/farm-device-mapping',
  BULK_IOT_MAPPING_CSV: '/iot/farm-device-mapping/bulk/csv',
}
